var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ArcBaseService } from './arc-base.service';
import { LoadingService } from './loading.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
import { loadModules } from 'esri-loader';
var ReviewResponseLU = /** @class */ (function () {
    function ReviewResponseLU() {
    }
    return ReviewResponseLU;
}());
export { ReviewResponseLU };
var ReviewResponseLuService = /** @class */ (function (_super) {
    __extends(ReviewResponseLuService, _super);
    function ReviewResponseLuService(snackBar, loadingService) {
        return _super.call(this, '12', snackBar, loadingService) || this;
    }
    ReviewResponseLuService.prototype.create_new_review_response = function (project_fk, response) {
        var vm = this;
        var config = new ConfigService();
        return new Observable(function (obs) {
            vm.layerIsLoaded.subscribe(function () {
                loadModules(['esri/graphic', 'esri/geometry/Polygon', 'esri/SpatialReference'], config.jsapi_config).then(function (_a) {
                    var Graphic = _a[0], Polygon = _a[1], SpatialReference = _a[2];
                    var reviewResponse = new Graphic(vm.layer.templates[0].prototype.toJson());
                    reviewResponse.attributes.GlobalID = 'new';
                    reviewResponse.attributes.projects_fk = project_fk;
                    reviewResponse.attributes.Review_Response = response;
                    vm.addFeature(reviewResponse, true).subscribe();
                    obs.next(reviewResponse);
                    obs.complete();
                });
            });
        });
    };
    return ReviewResponseLuService;
}(ArcBaseService));
export { ReviewResponseLuService };
